import { UseQueryOptions, queryOptions } from '@tanstack/react-query';

import { SearchProductsResponse, SearchShopProductsParams, searchShopProducts } from '~/apis/search';

export const searchShopProductsQueryOptions = (
  request: SearchShopProductsParams,
  { enabled, staleTime }: Pick<UseQueryOptions, 'enabled' | 'staleTime'>,
  token = '',
) => {
  return queryOptions({
    queryKey: ['search', 'shop', 'products', { ...request }],
    queryFn: () => {
      return searchShopProducts(request, {
        // server-side 에서 직접 토큰 주입시 request header 에 token 직접 설정
        ...(token && {
          headers: {
            'X-BUN-AUTH-TOKEN': token,
          },
        }),
      }) as Promise<SearchProductsResponse>;
    },
    select: (data) => data.data,
    placeholderData: (data) => data,
    enabled,
    staleTime: staleTime ?? 3 * 1000,
    throwOnError: true,
    retry: 0,
    refetchOnWindowFocus: false,
  });
};
